import request from "@/utils/request";

// 修改密码
export const changePasswordApi = (data) =>
  request({
    url: "/bd/user/updatePassword",
    method: "post",
    data,
    headers: { "Content-Type": "application/json" },
  });
